import React, { Component } from 'react';
import PropTypes from 'prop-types';
import envConfig from '../../../static/config';
import _ from 'lodash';
import SessionStore from '../../stores/SessionStore';
import AnalyticsUtil from '../../utils/AnalyticsUtil';
import config from '../../config/index';
import Helmet from 'react-helmet';
import { sayLandingMessage } from '../../actions/AccessibilityActionCreator';
import NavigateToWebApps from '../../utils/NavigateToWebApps';
import ProductPageUtils from '../../utils/ProductPageUtils';

import { Inline } from 'web-ui-components/lib/layout/grids';
import { GenericModal } from 'web-ui-components/lib/layout/content';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { DataManagementShell } from 'web-ui-components/lib/layout/shells';
import { SubHeading } from 'web-ui-components/lib/typography/headings';

import 'picturefill';

class ProductDetails extends Component {
  constructor(props) {
    super(props);
    this.onProductClick = this.onProductClick.bind(this);
    this.continue = this.continue.bind(this);
    this.cancel = this.cancel.bind(this);
    this.getProducts = this.getProducts.bind(this);
    this.state = {
      show: false,
      dynamicProduct: {
        name: 'Private banking',
        link: '{bankUrl}/private/',
      },
      bankId:
        SessionStore.getSessionBankID() ||
        envConfig.apiBankId ||
        envConfig.brandId,
      productList: ProductPageUtils.getProductList(
        this.props.isPersonalProduct
      ),
    };
  }

  componentDidMount() {
    sayLandingMessage('Product');
    AnalyticsUtil.analyticAction(
      config.analytics.analytics_experience_view,
      config.analytics.analytics_event_method_appeared,
      'PageLoaded'
    );
  }

  onProductClick(e, product) {
    e.preventDefault();
    const { isWebApp, link } = product;

    if (isWebApp) {
      NavigateToWebApps.navigateTo(link);
    } else {
      this.setState({ show: true, dynamicProduct: product });
      this.decideContent(product);
    }
  }

  getProducts() {
    const { productList } = this.state;
    const productObject = [];
    if (productList.length) {
      _.map(productList, (product, i) => {
        product.link = product.link.replace(
          '{bankUrl}',
          envConfig.brochurewareUrl
        );
        const productItem = React.createElement(product.type, {
          labelText: product.labelText,
          onClick: (e) => this.onProductClick(e, product),
        });
        productObject.push(productItem);
      });
      return productObject;
    }
  }

  continue() {
    const { link, isWebApp } = this.state.dynamicProduct;
    this.setState({ show: false });
    const {
      analytics_experience_activity,
      analytics_event_method_cta,
      analytics_behaviour_positive,
    } = config.analytics;
    AnalyticsUtil.analyticAction(
      analytics_experience_activity,
      analytics_event_method_cta,
      analytics_behaviour_positive
    );

    if (isWebApp) {
      NavigateToWebApps.navigateTo(link);
    } else {
      window.open(link);
    }
  }

  cancel() {
    AnalyticsUtil.analyticAction(
      config.analytics.analytics_experience_activity,
      config.analytics.analytics_event_method_cta,
      config.analytics.analytics_behaviour_neutral
    );
    this.setState({ show: false });
  }

  render() {
    const { content, isPersonalProduct } = this.props;
    const {
      products,
      businessProducts,
      businessProductsContent,
      businessProductsContent1,
      productsContent1,
      productsContent2,
      productsContent3,
      modalHeading,
      cancelButtonText,
      continueButtonText,
      productsModelContent,
    } = content;
    const productTitle = isPersonalProduct ? products : businessProducts;
    return (
      <div>
        <Helmet title={products} />
        <h1 id="accessH1ID" ref="accessH1ID" className="u-visually-hidden">
          You are on Products page
        </h1>
        <DataManagementShell mainId="site-main">
          <SubHeading>{productTitle}</SubHeading>
          {isPersonalProduct ? (
            <StandardBody>
              <p>{productsContent1}</p>
              <p>{productsContent2}</p>
              <p>{productsContent3}</p>
            </StandardBody>
          ) : (
            <StandardBody>
              <p>{businessProductsContent}</p>
              <p>{businessProductsContent1}</p>
            </StandardBody>
          )}
          <Inline.Thirds nodes={this.getProducts()} />
          <GenericModal
            titleText={modalHeading}
            onConfirm={this.continue}
            isOpen={this.state.show}
            onClose={this.cancel}
            dismissButtonText={cancelButtonText}
            confirmButtonText={continueButtonText}
          >
            <StandardBody>
              <p>{productsModelContent}</p>
            </StandardBody>
          </GenericModal>
        </DataManagementShell>
      </div>
    );
  }
}

ProductDetails.propTypes = {
  content: PropTypes.object,
  isPersonalProduct: PropTypes.bool,
};

export default ProductDetails;
